import type { ReactNode } from 'react';

export function TextField({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  autoComplete,
  inputMode,
  prefix,
  trailing,
  autoFocus,
  maxLength
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: string;
  placeholder?: string;
  autoComplete?: string;
  inputMode?: 'text' | 'email' | 'numeric';
  prefix?: ReactNode;
  trailing?: ReactNode;
  autoFocus?: boolean;
  maxLength?: number;
}) {
  return (
    <label className="block">
      <span className="mb-[7px] block text-[11px] font-bold uppercase tracking-eyebrow text-ink2">
        {label}
      </span>
      <div className="flex items-center gap-2 rounded-2xl border border-black/5 bg-card px-4 shadow-tile transition-colors focus-within:border-accent-ink/40">
        {prefix && <span className="text-ink3">{prefix}</span>}
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          inputMode={inputMode}
          autoFocus={autoFocus}
          maxLength={maxLength}
          className="w-full bg-transparent py-[14px] text-[15px] font-medium text-ink outline-none placeholder:text-ink3"
        />
        {trailing}
      </div>
    </label>
  );
}
